import { ConfiguracoesCoreService } from 'src/app/domain/primecap/core/configuracoes-core.service';
import { SnackBarService } from '../../../../../shared/snack-bar.service';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TokenService } from 'src/app/services/token.service';
import { PushInterface } from '../../../model/interface/push-interface';
import { Push } from '../../../model/push';
import { PushCoreService } from '../../../core/push-core.service';
import { DadosModal } from '../../../model/dados-modal';
import { PushConfirme } from '../model/push';
import { Subscription } from 'rxjs';
import { ProgressPageService } from '../progress-page.service';

export interface DialogData{
  startup: string,
  valorDoInvestimento: number,
  nomeInvestidor: string
}

@Component({
  selector: 'app-modal-push',
  templateUrl: './modal-push.component.html',
  styleUrls: ['./modal-push.component.css']
})
export class ModalPushComponent implements OnInit {

  @Input() confirmacaoPush: any;
  investidor: string;
  form: UntypedFormGroup
  nomeInvestidor: string;
  push: PushConfirme
  disabled = false;
  termosServico: string;
  avisoRiscos: string;
  atualizaConfiguracoes$: Subscription;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ModalPushComponent>,
    private tokenService: TokenService,
    private pushCoreSevice: PushCoreService,
    private progressPageService: ProgressPageService,
    private router: Router,
    private snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) public data: DadosModal<PushConfirme>,
    private configuracoesCoreService: ConfiguracoesCoreService
  ) {
      this.nomeInvestidor = data.objeto.nomeInvestidor;
      this.push = data.objeto;

      this.atualizaConfiguracoes$ = this.configuracoesCoreService.atualizaConfiguracoes$.subscribe(
        config => {
          this.termosServico = config.termosServico;
          this.avisoRiscos = config.avisoRiscos;
        }
      );
  }

  ngOnDestroy(): void {
    this.atualizaConfiguracoes$.unsubscribe();
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      termoServico: [false],
      avisoRiscos: [false],
      investidor: ['',[comparaNomeInvestidor(this.nomeInvestidor)]]
    },)
  }

  validaForm(){
    if(this.form.get('investidor')?.errors?.investidorConfirmado && this.form.controls['avisoRiscos'].value && this.form.controls['termoServico'].value){
      return false
    }else{
      return true
    }

  }

  enviarPush(){
    const postPush : PushInterface = {
      investidorUuid:this.push.uuid,
      valor: this.push.valorInvestimento,
      rodadaUuid: this.push.uuidRodada,
      termosServico: true,
      avisoRiscos: true,
      confirmacaoNomeInvestidor: this.form.value.investidor
    }
    const uudiAssessor = this.tokenService.carregarUsuarioLogado().uuidTipoUsuario
    this.pushCoreSevice.postPush(new Push(postPush), uudiAssessor).subscribe(
      res => {
        this.snackBarService.exibirMensagem(`Investimento encaminhado para análise!`, false);
        this.progressPageService.setInfoPush(postPush);
        this.router.navigateByUrl('confirmacao-investimento/push/true');
      },
    )
  }

}

export function comparaNomeInvestidor(nomeInvestidor: string){
  return (control: AbstractControl) => {
    const mesmoNome = control?.value?.toLowerCase().trim() == nomeInvestidor?.toLowerCase().trim()
    return (mesmoNome ? {investidorConfirmado : true} : null)
  }
}
